function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { FaChevronRight } from 'react-icons/fa';
import HamburgerLink from './HamburgerLink.react';
var HamburgerItem = function HamburgerItem(_ref) {
  var url = _ref.url,
    action = _ref.action,
    title = _ref.title,
    children = _ref.children,
    pathname = _ref.pathname,
    permission = _ref.permission;
  var _useState = useState(uuid()),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    open = _useState4[0],
    setOpen = _useState4[1];
  useEffect(function () {
    $(document).on('hamburger-toggle', function (e, data) {
      if (data.id === id) return;else setOpen(false);
    });
    return function () {
      $(document).off('hamburger-toggle');
    };
  }, []);
  useEffect(function () {
    if (open) {
      $("#".concat(id)).css({
        height: 70 + $("#".concat(id, " .hamburger__subnav")).height()
        // backgroundColor: '#2f4050',
      });
    } else {
      $("#".concat(id)).css({
        height: 70
        // backgroundColor: 'transparent',
      });
    }
  }, [open]);
  return /*#__PURE__*/React.createElement("div", {
    className: "hamburger__item",
    id: id,
    key: id
  }, /*#__PURE__*/React.createElement(HamburgerLink, {
    url: url,
    action: action,
    active: open,
    permission: permission,
    onClick: function onClick() {
      $.event.trigger('hamburger-toggle', {
        id: id
      });
      if (!children) return;
      setOpen(!open);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "hamburger__link--title"
  }, /*#__PURE__*/React.createElement("p", null, title))), children && /*#__PURE__*/React.createElement("div", {
    className: "hamburger__subnav"
  }, children.map(function (y) {
    return /*#__PURE__*/React.createElement(HamburgerLink, _extends({}, y, {
      active: pathname === y.url,
      child: true,
      key: "".concat(id).concat(y.title)
    }), /*#__PURE__*/React.createElement("div", {
      className: "hamburger__link--title"
    }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(FaChevronRight, null), y.title)));
  })));
};
export default HamburgerItem;